import { __spreadArray } from '../../../_virtual/_tslib.js';
import { useState } from 'react';

var useLikedByMembersListModal = function (_a) {
    var userAvatarPreference = _a.userAvatarPreference, callGetLikedByMembersListApi = _a.callGetLikedByMembersListApi;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = useState([]), data = _c[0], setData = _c[1];
    var _d = useState(0), total = _d[0], setTotal = _d[1];
    var _e = useState(0), page = _e[0], setPage = _e[1];
    var _f = useState(false), isLoading = _f[0], setIsLoading = _f[1];
    var onCallGetLikedByMembersListApi = function (_a) {
        var pageArg = _a.page;
        if (isLoading)
            return;
        setIsLoading(true);
        callGetLikedByMembersListApi({ page: pageArg })
            .then(function (response) {
            var responseData = (response === null || response === void 0 ? void 0 : response.data) || {};
            if (page === 1) {
                setData(responseData.members);
            }
            else {
                setData(__spreadArray(__spreadArray([], data, true), responseData.members, true));
            }
            setTotal(responseData.total || 0);
            setPage(pageArg);
        })
            .finally(function () { return setIsLoading(false); });
    };
    var open = function () {
        setIsOpen(true);
        onCallGetLikedByMembersListApi({ page: 1 });
    };
    var onLoadMore = function () {
        if (data.length < total)
            onCallGetLikedByMembersListApi({ page: page + 1 });
    };
    /**
     * TODO(DEV) - This method of infinite scroll wont work in case screen size is too big and
     *  number of element doesnt overflow the list to have scroll functionality.
     * For now since page_size is 50 the case wont come but in case page_size becomes 5 and screen size is big
     * we wont have a scroll it wont be able to fetch more items.
     */
    var loadMoreOnScroll = function (e) {
        if (!e.target)
            return;
        var _a = e.target, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
        if (scrollTop + clientHeight >= scrollHeight)
            onLoadMore();
    };
    var onClose = function () {
        setIsOpen(false);
    };
    return {
        isOpen: isOpen,
        data: data,
        total: total,
        open: open,
        onClose: onClose,
        loadMoreOnScroll: loadMoreOnScroll,
        userAvatarPreference: userAvatarPreference,
    };
};

export { useLikedByMembersListModal };
//# sourceMappingURL=useLikedByUsersListModal.js.map
